import { auth } from '@/lib/firebase';

const API_BASE = '/api/v1';

// Kept warm so media URLs (<img>/<video> src can't carry headers) can append a token synchronously
let cachedToken: string | null = null;
auth.onIdTokenChanged((user) => {
  if (!user) {
    cachedToken = null;
    return;
  }
  user
    .getIdToken()
    .then((token) => {
      cachedToken = token;
    })
    .catch(() => {});
});

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    cachedToken = token;
    headers.set('Authorization', `Bearer ${token}`);
  } else if (import.meta.env.DEV) {
    // Local dev runs with LabOSAuthMock (no Firebase user); emulator honors this header
    headers.set('x-dev-role', 'admin');
  }
  return fetch(`${API_BASE}${path}`, { ...init, headers });
}

export function withToken(url: string): string {
  const sep = url.includes('?') ? '&' : '?';
  if (cachedToken) return `${url}${sep}access_token=${encodeURIComponent(cachedToken)}`;
  if (import.meta.env.DEV) return `${url}${sep}dev_role=admin`;
  return url;
}
